/* eslint-disable react/no-deprecated */
import { Component } from 'react';

import allWidgets from 'legacy/javascripts/components/widgets';

class Overview extends Component {
  render() {
    let styles = {
      width: '25%',
      textAlign: 'center',
      margin: '10px 0 20px 0',
      display: 'inline-block',
    };

    const widgets = this.props.data.map(widget => {
      let Widget = allWidgets[widget.klass];
      return <Widget key={widget.klass} {...widget} />;
    });

    return <div className="overview">{widgets}</div>;
  }
}

export default Overview;
/* eslint-enable react/no-deprecated */
